// @flow
import { useJsonForms, ctxToLayoutProps } from '@jsonforms/react';

const useViewLayoutProps = (props: $FixMe): $FixMe => {
    const ctx = useJsonForms();
    return ctxToLayoutProps(ctx, props);
};

export default useViewLayoutProps;
